import React from 'react';
import { Reveal } from './Reveal';
type Review = {
  initials: string;
  quote: string;
  name: string;
  role: string;
};
const reviews: Review[] = [{
  initials: 'CR',
  quote: 'I was terrified to charge for my services. Volume 5 showed me exactly how to structure sessions like a real professional. I tripled my rates and my clients respect me more. This system gave me permission to be legitimate.',
  name: 'Catherine R.',
  role: 'Toronto, Canada · Energy Healer'
}, {
  initials: 'DT',
  quote: 'The Symptom Map changed everything with my chronic pain clients. I can now explain WHY they have pain, not just help them feel better. They understand themselves better and the work goes deeper. Game-changer.',
  name: 'David T.',
  role: 'Sydney, Australia · Holistic Therapist'
}, {
  initials: 'NP',
  quote: 'I wanted to train Reiki students but had no framework. Volume 3 gave me the complete blueprint. I now have 12 students going through my certification program. This investment built my entire business.',
  name: 'Natalia P.',
  role: 'Madrid, Spain · Reiki Master & Trainer'
}];
export function Reviews() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-203" data-mp="2he7wz87dn7bq">
      <div className="mx-auto max-w-6xl" data-id="element-204" data-mp="2herh8vki27sx">
        <Reveal className="text-center" data-id="element-205" data-mp="2ddeb0kdhw2lh">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-206" data-mp="2deh1wsati51e">
            ⭐ More Real Results from <span className="text-sage" data-id="element-207" data-mp="3a2nbltmljnmj">Real People</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-208" data-mp="353shhvj6icn4">
            4.8/5 · Hundreds of practitioners already building professional practices.
          </p>
        </Reveal>
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-209" data-mp="30azdj9vjb8c3">
          {reviews.map((review, index) => <Reveal key={review.initials} delay={index * 0.05} className="h-full" data-id="element-210" data-mp="2w9xlbd01bwjm" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-navy/10 bg-surface p-7 shadow-premium" data-id="element-211" data-mp="3svr9xsareonh">
                <div className="text-amber" aria-label="5 out of 5 stars" data-id="element-212" data-mp="1m5e2apf8vza8">
                  ★★★★★
                </div>
                <blockquote className="mt-5 flex-1 text-[15px] leading-7 text-slate" data-id="element-213" data-mp="1r50kzedue7qf">
                  “{review.quote}”
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-3" data-id="element-214" data-mp="1cfb4mbx6hx5k">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sage/15 text-sm font-bold text-sage" data-id="element-215" data-mp="1hdcx1nghv8tp">
                    {review.initials}
                  </span>
                  <span data-id="element-216" data-mp="18f0ucn2cskkw">
                    <span className="block font-bold text-navy" data-id="element-217" data-mp="18faq6ra2xlyi">{review.name}</span>
                    <span className="mt-0.5 block text-xs text-slate" data-id="element-218" data-mp="ti0cdb9ys3zm">{review.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}